module.exports = __webpack_public_path__ + "static/media/zara_logo.8c8059fc.png";